export function flowParallel(pen, ctx) {
  const path = !ctx ? new Path2D() : ctx;
  const {x, y, ex, ey} = pen.calculative.worldRect;

  path.moveTo(x, y);
  path.lineTo(ex, y);
  path.moveTo(x, ey);
  path.lineTo(ex, ey);
  if (path instanceof Path2D) return path;
}

export function flowParallelAnchors(pen) {
  const points = [
    {
      x: 0.5,
      y: 0,
    },
    {
      x: 0.5,
      y: 1,
    },
  ];
  pen.anchors = points.map(({x, y}, index) => {
    return {
      id: index + '',
      x,
      y,
      penId: pen.id,
    };
  });
}
